'use strict';

angular.module('amexReconciliationApp')
  .directive('characterCount', function characterCount() {

    return {
      restrict: 'E',
      scope: {
        text: '@',
        warningLength: '@',
        maxLength: '@',
        dangerLength: '@'
      },
      controller: function CharacterCountController() {

        this.isWarningLength = function () {
          return this.text.length >= this.warningLength;
        };

        this.isDangerLength = function () {
          return this.text.length >= this.dangerLength;
        };

        this.charactersRemaining = function () {
          return this.maxLength - this.text.length;
        };

      },
      controllerAs: 'characterCount',
      bindToController: true,
      templateUrl: 'scripts/views/character-count.html'
    };

  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/characterCount.js
// module id = 517
// module chunks = 0